import messages from '../../../locale/messages';
import { inputTextLimit } from '../../../helpers/fieldRestriction';

const validate = values => {

  const errors = {}

  if (!values.reason) {
    errors.reason = messages.reasonRequired;
  } else if (values.reason.trim() == "") {
    errors.reason = messages.reasonRequired
  } else if (values?.reason.length > inputTextLimit) {
    errors.reason = messages.textAreaError
  }

  return errors
}

export default validate
